import type { CSSProperties, ReactNode } from 'react'

export interface IconProps {
  /** Tamaño en px (ancho = alto). Por defecto 24. */
  size?: number
  className?: string
  style?: CSSProperties
  /**
   * Etiqueta accesible. Si se indica, el icono es INFORMATIVO
   * (`role="img"` + `aria-label`). Si se omite, es DECORATIVO (`aria-hidden`),
   * que es el caso por defecto (el color y el texto los aporta el contenedor).
   */
  label?: string
}

interface SvgIconProps extends IconProps {
  /** viewBox nativo del trazado (se preserva del diseño original). */
  viewBox: string
  children: ReactNode
}

/**
 * Primitivo interno de todos los iconos del DS. Centraliza tamaño, color
 * (`currentColor`, heredado del contenedor) y, sobre todo, la accesibilidad:
 * decorativo por defecto, informativo cuando recibe `label`.
 */
export function SvgIcon({ size = 24, className, style, label, viewBox, children }: SvgIconProps) {
  const a11y = label
    ? { role: 'img' as const, 'aria-label': label }
    : { 'aria-hidden': true as const, focusable: 'false' as const }

  return (
    <svg
      width={size}
      height={size}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...a11y}
    >
      {children}
    </svg>
  )
}
